"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PulldownButton = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const react_jss_1 = __importDefault(require("react-jss"));
const pulldown_button_style_1 = __importDefault(require("./pulldown.button.style"));
const icons_1 = require("../../icons");
class PulldownButton extends react_1.default.PureComponent {
    constructor() {
        super(...arguments);
        this.render = () => {
            const { classes, children, buttonRef, onClick, expanded, primary, secondary, warning, disabled } = this.props;
            const rootProps = {
                onClick,
                type: 'button',
                className: classes.root,
                disabled,
                ref: buttonRef,
                'data-is-primary': primary,
                'data-is-secondary': secondary,
                'data-is-warning': warning,
                'aria-expanded': expanded,
                'aria-haspopup': true
            };
            return (jsx_runtime_1.jsxs("button", Object.assign({}, rootProps, { children: [jsx_runtime_1.jsx("span", Object.assign({ className: classes.text }, { children: children }), void 0),
                    jsx_runtime_1.jsx("span", Object.assign({ className: classes.icon }, { children: jsx_runtime_1.jsx(icons_1.icons.ArrowDown, { size: 17 }, void 0) }), void 0)] }), void 0));
        };
    }
}
exports.PulldownButton = PulldownButton;
PulldownButton.propTypes = {
    classes: prop_types_1.default.object.isRequired,
    children: prop_types_1.default.node.isRequired,
    buttonRef: prop_types_1.default.func.isRequired,
    onClick: prop_types_1.default.func.isRequired,
    expanded: prop_types_1.default.bool.isRequired,
    disabled: prop_types_1.default.bool.isRequired,
    primary: prop_types_1.default.bool.isRequired,
    secondary: prop_types_1.default.bool.isRequired,
    warning: prop_types_1.default.bool.isRequired
};
exports.default = react_jss_1.default(pulldown_button_style_1.default)(PulldownButton);
//# sourceMappingURL=pulldown.button.js.map